export function checkOldBrowser(userAgent) {
  return userAgent.match(/(?:MSIE|Trident)/);
}

export function generateBrowserWarningElement(callback) {
  const el = document.createElement('div');

  // Styling
  el.style.position = 'fixed';
  el.style.top = '0';
  el.style.right = '0';
  el.style.bottom = '0';
  el.style.left = '0';
  el.style.backgroundColor = '#000000';
  el.style.width = '100%';
  el.style.height = '100%';

  // Click to close
  el.onclick = () => {
    el.parentNode.removeChild(el);
    callback();
  };

  // Content
  const content = document.createElement('span');
  content.style.color = '#fff';
  content.style.textAlign = 'center';
  content.style.width = '100%';
  content.style.display = 'block';
  content.style.padding = '20%';
  content.style.boxSizing = 'border-box';
  content.innerHTML =
    'Your web browser is out of date. Please switch to another browser to ' +
    'continue with signing up for the study. Click anywhere on this page to close this warning.';

  el.appendChild(content);

  return el;
}
